export default {
	_config: null,
	init() {
	/* 	this._config = document.querySelector('[data-config]');
		this._config = JSON.parse(this._config.getAttribute('data-config'));
		if (this._GAisLoaded()) {
			this._create();
			this._send();
		} */
	},
};